import {
  FolderAddOutlined,
  PlusOutlined,
  SearchOutlined,
} from "@ant-design/icons";
import { ConfigProvider, FloatButton, Input, Spin, message } from "antd";
import { ReactComponent as Download } from "asset/mobile/download_m.svg";
import axios from "axios";
import style from "css/address.module.css";
import NoAddress from "pages/address/mobile/component/noAddress";
import { useCallback, useLayoutEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import AddressList from "./component/addressList";
import AddressPopup from "./component/addressPopup";
import AddressUploadPopup from "./component/addressUploadPopup";

function AddressMobile() {
  const { t } = useTranslation();

  const scrollViewRef = useRef(null);
  const isLoadingRef = useRef(true);

  const [init, setInit] = useState(true);
  const [searchText, setSearchText] = useState("");
  //   const [selectedTag, setSelectedTag] = useState("");

  const [list, setList] = useState([]);
  const [tagList, setTagList] = useState([]);
  const [selectList, setSelectList] = useState([]);
  const [popupData, setPopupData] = useState(null);

  // const [isLoading, setIsLoading] = useState(true);
  const [isExcelDownloading, setIsExcelDownloading] = useState(false);
  const [isAddressPopupOpen, setIsAddressPopupOpen] = useState(false);
  const [isUploadPopupOpen, setIsUploadPopupOpen] = useState(false);
  const [isFloatOpen, setIsFloatOpen] = useState(false);

  const getList = useCallback(() => {
    isLoadingRef.current = true;
    const config = { params: {} };

    if (searchText !== "") {
      config.params.search_text = searchText;
    }
    axios
      .get("/address/list", config)
      .then((res) => {
        if (res.status === 200) {
          setList(res.data);
        }
      })
      .finally(() => {
        scrollViewRef.current.style.transform = `translateY(-50px)`;
        isLoadingRef.current = false;
      });
  }, [searchText]);

  const getTagList = useCallback(() => {
    const config = { params: {} };

    if (searchText !== "") {
      config.params.search_text = searchText;
    }

    axios.get("/address/tag", config).then((res) => {
      if (res.status === 200) {
        setTagList(res.data);
      }
    });
  }, [searchText]);

  useLayoutEffect(() => {
    if (init) {
      getList();
      getTagList();
      setSelectList([]);
      setPopupData(null);
      setInit(false);
    }
  }, [getList, getTagList, init]);

  const closePopupHandler = () => {
    setInit(true);
    setIsAddressPopupOpen(false);
    setIsUploadPopupOpen(false);
  };

  // 연락처 > 엑셀 다운로드
  const downloadAddressToExcel = () => {
    let selectDataList =
      selectList.length > 0
        ? list.filter((item) => selectList.includes(item.key))
        : [];
    const data = selectDataList.length > 0 ? selectDataList : list;

    if (data.length === 0) {
      message.warning(t("MESSAGE.NO_CONTACT_INFO"));
      return;
    }

    setIsExcelDownloading(true);

    const config = {
      responseType: "blob",
    };
    axios
      .post("/address/excel", data, config)
      .then((res) => {
        const url = window.URL.createObjectURL(
          new Blob([res.data], { type: res.headers["content-type"] })
        );
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", t("LABEL.CONTACT") + ".xlsx");
        document.body.appendChild(link);
        link.click();
      })
      .finally(() => {
        setIsExcelDownloading(false);
      });
  };

  // 연락처 삭제
  const deleteAddress = (address_id) => {
    if (address_id === undefined) alert("No address id");
    // setIsLoading(true);

    const config = {
      params: {
        address_id: address_id,
      },
    };

    axios
      .delete("/address/info", config)
      .then((res) => {
        if (res.status === 200) {
          message.success(
            t("MESSAGE.CONTACT_DELETE_SUCCESS", {
              NAME: list.filter((addr) => addr.key === address_id)[0].name,
            })
          );
          setInit(true);
        }
      })
      .catch((err) => message.error(t("MESSAGE.CONTACT_DELETE_FAIL")))
      .finally(() => {
        // setIsLoading(false);
      });
  };

  const checkBoxHandler = (e) => {
    const addrKey = e.target.value;
    const isChecked = e.target.checked;

    if (isChecked) {
      setSelectList((prevSelectList) => [...prevSelectList, addrKey]);
    } else {
      const tmpList = selectList.filter((select) => select !== addrKey);
      setSelectList(tmpList);
    }
  };

  // 연락처 수정 팝업 열 때 기존의 연락처 데이터를 popupData에 set
  const openDataHandler = (data) => {
    setPopupData(data);
    setIsAddressPopupOpen(true);
  };

  const uploadPopupOpenHandler = () => {
    setIsUploadPopupOpen(true);
    setIsFloatOpen(false);
  };

  ///////// pullToRefresh //////////
  useLayoutEffect(() => {
    // if (isOpen) {
    // DOM이 업데이트될 때까지 기다림
    if (scrollViewRef.current) {
      const main = document.querySelector(".scrollView-container-addr");

      // if (!main) {
      //     message.error("Failed to load AlarmBar");
      //     close();
      //     return;
      // }

      let scrollStart = 0;
      // let scrollMoving = 0;
      // let scrollEnd = 0;
      const pStart = { x: 0, y: 0 };
      const pCurrent = { x: 0, y: 0 };

      function loadData() {
        if (isLoadingRef.current) return;

        main.style.transform = `translateY(0px)`;

        setTimeout(() => {
          setInit(true);
        }, 500);
      }

      function swipeStart(e) {
        scrollStart = scrollViewRef.current.scrollTop;
        let touch = e.targetTouches ? e.targetTouches[0] : e;
        pStart.x = touch.screenX;
        pStart.y = touch.screenY;
      }

      // function swipeEnd(e) {
      //     // scrollEnd = scrollViewRef.current.scrollTop;
      //     if (document.body.scrollTop === 0 && !isLoading) {
      //     }
      // }

      function swipe(e) {
        // scrollMoving = scrollViewRef.current.scrollTop;
        let touch = e.changedTouches ? e.changedTouches[0] : e;
        pCurrent.x = touch.screenX;
        pCurrent.y = touch.screenY;

        let changeY = Math.max(0, pCurrent.y - pStart.y);

        if (document.body.scrollTop === 0) {
          if (scrollStart === 0 && changeY > 100) {
            loadData();
          }
        }
      }

      document.addEventListener("touchstart", swipeStart, false);
      document.addEventListener("touchmove", swipe, false);
      // iPhone에 기본 내려서 새로고침 막기
      // document.addEventListener("touchmove", (event) => { if (window.scrollY === 0) event.preventDefault() }, { passive: false });
      // document.addEventListener("touchend", swipeEnd, false);

      return () => {
        document.removeEventListener("touchstart", swipeStart);
        document.removeEventListener("touchmove", swipe);
        // document.removeEventListener("touchend", swipeEnd);
      };
    }
    // }
  }, []);

  return (
    <div className={style.wrapper}>
      <AddressPopup
        isOpen={isAddressPopupOpen}
        closePopup={closePopupHandler}
        info={popupData}
        tagList={tagList}
      />
      <AddressUploadPopup
        isOpen={isUploadPopupOpen}
        closePopup={closePopupHandler}
      />
      <div className={style.container}>
        <div className={style.addr_search_wrapper}>
          <div className={style.addr_search_container}>
            <Input
              className={style.addr_search_input}
              placeholder={t("PLACEHOLDER.SEARCH.MAIL_NAME")}
              onChange={(e) => setSearchText(e.target.value)}
              onKeyDown={(e) => {
                if (e.key === "Enter") {
                  setInit(true);
                }
              }}
              suffix={
                <SearchOutlined
                  className="search-btn"
                  style={{ color: "#707070" }}
                  onClick={() => setInit(true)}
                />
              }
            />
            <button
              className={style.addr_downloadBtn}
              onClick={downloadAddressToExcel}
            >
              <Download />
              {isExcelDownloading ? <Spin /> : t("BTN.DOWNLOAD_EXCEL")}
            </button>
          </div>
        </div>
        <div ref={scrollViewRef} className="scrollView-container-addr">
          <div className="scrollView-loading">
            <Spin />
          </div>
          {isLoadingRef.current ? (
            <div className={style.loading_container}>
              <Spin />
            </div>
          ) : list.length > 0 ? (
            <AddressList
              addrList={list}
              tagList={tagList}
              deleteAddress={deleteAddress}
              checkBoxHandler={checkBoxHandler}
              openData={openDataHandler}
            />
          ) : (
            <NoAddress />
          )}
        </div>
      </div>
      <div>
        {isFloatOpen && <section className={style.float_background} />}
        <ConfigProvider
          theme={{
            token: {
              colorPrimary: "#1cb691",
              colorPrimaryHover: "#1cb691",
              controlHeightLG: 52,
            },
          }}
        >
          <FloatButton.Group
            trigger="click"
            type="primary"
            icon={<PlusOutlined />}
            open={isFloatOpen}
            onOpenChange={(open) => setIsFloatOpen(open)}
          >
            <div className={style.float_item}>
              <p className={style.float_title}>{t("BTN.UPLOAD")}</p>
              <FloatButton
                icon={<FolderAddOutlined className={style.float_icon} />}
                onClick={uploadPopupOpenHandler}
              />
            </div>

            <div className={style.float_item}>
              <p className={style.float_title}>
                {t("LABEL.TITLE.ADD_CONTACT")}
              </p>
              <FloatButton
                icon={<PlusOutlined className={style.float_icon} />}
                onClick={() => setIsAddressPopupOpen(true)}
              />
            </div>
          </FloatButton.Group>
        </ConfigProvider>
      </div>
    </div>
  );
}

export default AddressMobile;
